export const QUERY_PLACEHOLDER =
  'e.g. (Boolean): "avionic sensor" AND (thales OR safran)\n' +
  'e.g. (natural language): Nestlé\'s announcements regarding sustainability';
